import {getUserIdForGoogleAnalytics} from "cloud-central-utils/encryption";
import {aggregatePath, trackPageView, trackEvent} from "../mrTracker";
import {history} from "../../store";
import querystring from "query-string";

export const trackGaBeforeLogin = () => {
    if(process.env.REACT_APP_IS_SAAS !== "true") {
        return;
    }

    const search = querystring.parse(window.location.search);

    if(search?.redirectFrom && search.redirectFrom === "spot" && search.spotOrgId) {
        window.gtag('config', 'UA-115286337-3', {
            'page_location': window.origin + aggregatePath({location: window.location}),
            'send_page_view': false,
            'transport_type': 'beacon'
        });

        const label = search.spotOrgId;

        trackEvent({category: "Anon", action: `RedirectFrom:${search.redirectFrom}`, label})
    }
}

export const setGoogleAnalytics = authResult => {
    if(process.env.REACT_APP_IS_SAAS !== "true") {
        return;
    }

    if (authResult.idTokenPayload) {
        getUserIdForGoogleAnalytics(authResult.idTokenPayload.sub)
            .then(userId => {
                window.gtag('set', {'user_id': userId});
            });

        if (authResult.idTokenPayload['http://cloud.netapp.com/internal'] === "NetAppTest") {
            console.log("Analytics Disabled for Test Account");
            window['ga-disable-UA-115286337-3'] = true;
        } else {
            window.gtag('config', 'UA-115286337-3', {
                'custom_map': {
                    'dimension1': "internal",
                    'dimension2': "accountId"
                },
                'page_location': window.origin + aggregatePath({location: window.location}),
                'send_page_view': false,
                'transport_type': 'beacon'
            });

            if (authResult.idTokenPayload['http://cloud.netapp.com/internal']) {
                window.gtag('set', {'internal': authResult.idTokenPayload['http://cloud.netapp.com/internal']});
            }
        }
    }
};

export const setGaAccount = (accountId) => {
    window.gtag('set', {accountId});

    trackPageView({ location: window.location });
    history.listen((location) => {
        trackPageView({ location });
    });
}
